import { render, staticRenderFns } from "./EmptyRecord.vue?vue&type=template&id=028c82d4&"
import script from "./EmptyRecord.vue?vue&type=script&lang=js&"
export * from "./EmptyRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports